import React from 'react';
import {Box} from "@mui/material";
import {useTheme} from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Settings from "./components/Settings";
import AITraining from "./components/AITraining";
import Dashboard from "./components/Dashboard";
import Flash from "./components/Flash/Index";

interface TabPanelProps {
    children?: React.ReactNode;
    dir?: string;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    {children}
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

function App() {
    const theme = useTheme();
    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <Box sx={{bgcolor: 'background.paper'}}>
            <Flash/>
            <AppBar position="static">
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="secondary"
                    textColor="inherit"
                    variant="fullWidth"
                    aria-label="full width tabs example"
                >
                    <Tab label="Dashboard" {...a11yProps(0)} />
                    <Tab label="Settings" {...a11yProps(1)} />
                    <Tab label="Ai training" {...a11yProps(2)} />
                </Tabs>
            </AppBar>

            <TabPanel value={value} index={0} dir={theme.direction}>
                <Dashboard/>
            </TabPanel>

            <TabPanel value={value} index={1} dir={theme.direction}>
                <Settings/>
            </TabPanel>

            <TabPanel value={value} index={2} dir={theme.direction}>
                <AITraining/>
            </TabPanel>
        </Box>
    );
}

export default App;
